// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconFilesFileFileRemoved_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M17 0H5V30H15H18.5155H20.2675C19.9556 29.3791 19.7302 28.7071 19.6074 28H17.5121H15H7V2H17V0ZM27 16.0549V19.5042C26.917 19.5014 26.8337 19.5 26.75 19.5C26.1466 19.5 25.5604 19.5737 25 19.7126V16.0549V14V10H27V14V16.0549ZM19 0L27 8H19V0ZM32 26.75C32 29.6495 29.6495 32 26.75 32C23.8505 32 21.5 29.6495 21.5 26.75C21.5 23.8505 23.8505 21.5 26.75 21.5C29.6495 21.5 32 23.8505 32 26.75ZM27.7292 22.75L25.771 23.3886V27.6456H27.7292V22.75ZM27.7292 28.6246H25.771V30.5828H27.7292V28.6246Z" class="svg-bg"/>
</svg>
`;
/**
 * IconFilesFileFileRemoved is a generated icon component.
 */
let IconFilesFileFileRemoved = IconFilesFileFileRemoved_1 = class IconFilesFileFileRemoved extends IconBaseElement {
    render() {
        return html `${IconFilesFileFileRemoved_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconFilesFileFileRemoved.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconFilesFileFileRemoved = IconFilesFileFileRemoved_1 = __decorate([
    customElement('zui-icon-files-file-file-removed')
], IconFilesFileFileRemoved);
export { IconFilesFileFileRemoved };
